import {WebAnalyticsService} from "@vicman-wi/telemetry-js/esm/web-analytics/WebAnalyticsService";
import {stringIsTrueValue} from "@vicman-wi/utils-js/esm/string/is-true-value";
import {stringToNumbers} from "@vicman-wi/utils-js/esm/string/to-numbers";
import logger from "./logger";

let instance = null;

/** @return {WebAnalyticsService} */
export function getWebAnalyticsService() {
  if (instance) return instance;

  const userGroups = stringToNumbers(process.env.REACT_APP_ANALYTICS_USER_GROUPS);

  const service = new WebAnalyticsService(
    {
      isEnabled: stringIsTrueValue(process.env.REACT_APP_ANALYTICS_ENABLED),
      isMuted: userGroups.indexOf(window.clientConfig.splitGroupId) === -1,
      projectName: window.appConfig.project.name,
      clientToken: window.clientConfig.token,
    },
    logger()
  );

  service.setClientParams({
    webview_params: window.clientConfig.queryParams,
    client_type: window.clientConfig.isWebview
      ? "webview"
      : window.clientConfig.isWebMobile
        ? "mobile"
        : "desktop",
    is_webview: window.clientConfig.isWebview,
    is_mobile: window.clientConfig.isWebMobile,
    platform_browser_name: window.clientConfig.platform.name,
    platform_browser_version: window.clientConfig.platform.version,
    platform_os: window.clientConfig.platform.os,
    screen_w: window.screen.width,
    screen_h: window.screen.height,
    viewport_w: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
    viewport_h: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
    locale: window.clientConfig.locale,
    is_pro: window.clientConfig.isPro,
    split_group: window.clientConfig.splitGroupId,
  });

  if (window.clientConfig.isWebview) {
    const osName = window.clientConfig.isWebviewAndroid ? "Android" : "iOS";

    service.setClientParams({
      os_version: `${osName} ${window.clientConfig.queryParams.os_version}`,
      native_app_build: `${osName} ${window.clientConfig.queryParams.version_code}`,
    });
  }

  service.setGlobalEventParams({
    build_version: window.appConfig.build.version,
  });

  instance = service;
  return instance;
};